import { HelpIcon } from './HelpIcon';

export function MultiSelectField({ id, label, value = [], onChange, options = [], error, helpText, required, readOnly }) {
  const toggle = (v) => {
    if (readOnly) return;
    onChange(value.includes(v) ? value.filter(x => x !== v) : [...value, v]);
  };
  return (
    <div className="fw">
      <label className="fl">
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <div id={`field-${id}`} className={`ms-grid${error ? ' field-error-border' : ''}`} role="group" aria-label={label}>
        {options.map(o => (
          <button key={o.value} type="button" role="checkbox" aria-checked={value.includes(o.value)}
            onClick={() => toggle(o.value)} disabled={readOnly}
            className={`ms-chip${value.includes(o.value) ? ' ms-chip-on' : ''}`}>
            {value.includes(o.value) ? '✓ ' : ''}{o.label}
          </button>
        ))}
      </div>
      {value.length > 0 && <p className="ms-count">{value.length} selected</p>}
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
